import {HttpRequest,HttpMethod} from "./http";

class OrderProvider extends HttpRequest {

	
	GetShippingInfo(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/shipping/info`,params );
	}

	CreateOrder(params){
		return this.request(HttpMethod.Post,`/api/v1/orders`,params );
	}

	ListOrder(params){
		return this.request(HttpMethod.Get,`/api/v1/orders`,params );
	}

	ListOrderDetailProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/detail/product`,params );
	}

	ListOrderDetail(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/detail`,params );
	}

	UpdateOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}`,params );
	}

	CancelOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/cancel/${id}`,params );
	}

	ChangeTrackingOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/tracking/${id}`,params );
	}
	
	ChangeShippingOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/shipping/${id}`,params );
	}

	CheckTrackingOrder(id,params){
		return this.request(HttpMethod.Post,`/api/v1/orders/trackingcheck/${id}`,params );
	}
	// DeleteOrder(id){
	// 	return this.request(HttpMethod.Delete,`/api/v1/orders/${id}`);
	// }

	// Payment Success
	OrderPaymentConfirmSetStatusToAwaitingShipment(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/payment/confirm/success/${id}`,params );
	}

	OrderPaymentConfirmSetStatusToCancelled(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/payment/confirm/fail/${id}`,params );
	}

	// Change Delivery Status
	ChangeDeliveryStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}/delivery`,params );
	}

	// Change Packing Status
	ChangePackingStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}/packing`,params );
	}

	// Change Order Status
	ChangeOrderStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}/status`,params );
	}

	ListPaymentChannel(params){
		return this.request(HttpMethod.Get,`/api/v1/paymentmethod`,params );
	}

	ListSaleChannel(params){
		return this.request(HttpMethod.Get,`/api/v1/salechannel`,params );
	}

	ListFullAddress(params){
		return this.request(HttpMethod.Get,`/api/v1/address`,params );
	}

	ListFullAddressV2(params){
		return this.request(HttpMethod.Get,`/api/v2/address`,params );
	}

	ListProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/products`,params );
	}

	SyncPlatformOrder(params){
		return this.request(HttpMethod.Post,`/api/v2/platform/orders/sync`,params );
	}

	OrderReturn(params){
		return this.request(HttpMethod.Post,`/api/v2/orders/return`,params );
	}

	ReturnVideo(params){
		return this.request(HttpMethod.Post,`/api/v2/orders/return/vdo`,params );
	}
}

export default OrderProvider